import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { forwardRef, useContext, useRef, useState, useEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { border } from 'styled-system';
import { useMergeRefs } from 'use-callback-ref';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, palette, radius } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Cell } from './TableCell.es.js';
import { TableContext } from './TableContext.es.js';
import { useTableRowEventListener } from './Table.hooks.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Row = styled(Box).withConfig({
  componentId: "sc-1d8w0qk-0"
})(["display:table-row;color:inherit;outline:0;vertical-align:middle;", ";", ";", ";", ";", ""], function (_ref) {
  var hasFocus = _ref.hasFocus,
      isFocus = _ref.isFocus;
  return !!hasFocus && !!isFocus && css(["", "{position:relative;&::after{content:' ';width:100%;height:100%;position:absolute;top:0;left:0;z-index:-1;background-color:", ";}&:first-of-type::after{width:calc(100% + 12px);right:0;left:auto;border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-of-type::after{width:calc(100% + 12px);border-top-right-radius:", ";border-bottom-right-radius:", ";}}"], Cell, themeMode({
    light: css(["", ";"], palette("neutral.100")),
    dark: css(["", ";"], palette("neutral.900"))
  }), radius("base"), radius("base"), radius("base"), radius("base"));
}, function (_ref2) {
  var isRuled = _ref2.isRuled;
  return isRuled && css(["border-bottom:", ";"], themeMode({
    light: css(["1px solid ", ";"], palette("neutral.200")),
    dark: css(["1px solid ", ";"], palette("neutral.800"))
  }));
}, function (_ref3) {
  var hasHover = _ref3.hasHover;
  return !!hasHover && css(["", "{position:relative;&::after{content:' ';width:100%;height:100%;position:absolute;top:0;left:0;z-index:-1;}&:first-of-type::after{width:calc(100% + 12px);right:0;left:auto;border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-of-type::after{width:calc(100% + 12px);border-top-right-radius:", ";border-bottom-right-radius:", ";}}&:hover > ", "{&::after{background-color:", ";}}"], Cell, radius("base"), radius("base"), radius("base"), radius("base"), Cell, themeMode({
    light: css(["", ";"], palette("neutral.100")),
    dark: css(["", ";"], palette("neutral.900"))
  }));
}, function (_ref4) {
  var isSelected = _ref4.isSelected;
  return !!isSelected && css(["", "{position:relative;&::after{content:' ';width:100%;height:100%;position:absolute;top:0;left:0;z-index:-1;background-color:", ";}&:first-of-type::after{width:calc(100% + 12px);right:0;left:auto;border-radius:0;}&:last-of-type::after{width:calc(100% + 12px);border-radius:0;}}"], Cell, themeMode({
    light: css(["", ";"], palette("neutral.100")),
    dark: css(["", ";"], palette("neutral.900"))
  }));
}, border);
var TableRow =
/*#__PURE__*/
forwardRef(function (_a, forwardedRef) {
  var _b = _a,
      children = _b.children,
      _b$rowIndex = _b.rowIndex,
      rowIndex = _b$rowIndex === void 0 ? -1 : _b$rowIndex,
      _b$tabIndex = _b.tabIndex,
      tabIndex = _b$tabIndex === void 0 ? -1 : _b$tabIndex,
      props = __objRest(_b, ["children", "rowIndex", "tabIndex"]);

  var _useContext = useContext(TableContext),
      isRuled = _useContext.isRuled,
      dispatchRowChangedEvent = _useContext.dispatchRowChangedEvent,
      focusedRowIndexRef = _useContext.focusedRowIndexRef,
      onRowChange = _useContext.onRowChange;

  var rowRef = useRef(null);

  var _useState = useState(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var ref = useMergeRefs([forwardedRef, rowRef]);
  useTableRowEventListener(rowIndex, ref, isFocus, setIsFocus);
  useEffect(function () {
    if (focusedRowIndexRef && focusedRowIndexRef.current === rowIndex) {
      setIsFocus(true);
    }
  }, [focusedRowIndexRef, rowIndex]);
  var handleOnClick = useCallback(function (event) {
    dispatchRowChangedEvent(rowIndex, false);
    onRowChange && onRowChange(rowIndex, event);
  }, [dispatchRowChangedEvent, onRowChange, rowIndex]);
  return (
    /* @__PURE__ */
    React.createElement(Row, __spreadValues({
      onClick: handleOnClick,
      ref: ref,
      isRuled: isRuled,
      isFocus: isFocus,
      tabIndex: tabIndex
    }, props), children)
  );
});
export { TableRow };